import { CurrencyPipe, formatDate } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import LinearGradient from 'zrender/lib/graphic/LinearGradient';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { OverviewService } from './overview.service';
import { EChartsOption } from 'echarts';
import { Router } from '@angular/router';
import { JwtHelperService } from "@auth0/angular-jwt";
const helper = new JwtHelperService();


@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  providers: [CurrencyPipe]
})
export class OverviewComponent extends FeaturesBaseComponent implements OnInit {
 allRechargesData :any[] = []
  dateRange: any = [{ days: 1, value: '1 ', translatetitle:'pages.newRetailer.day' }, { days: 7, value: '1 ', translatetitle:'pages.newRetailer.week' }, { days: 30, value: '1 ',  translatetitle:'pages.newRetailer.month' },{days: 365, value: '',  translatetitle:'pages.newRetailer.all'}];
  selectedTopRetailersRange = this.dateRange[2].days;
  selectedTopProductsRange = this.dateRange[2].days;
  selectedTopStatesRange = this.dateRange[2].days;
  daysSelected: any;
  currentDate: Date;
  fromDate: any;
  totalRetailers: number =0;
  totalProducts: number=0;
  totalSalesCount: number =0;
  topRetailers: any = [];
  topProducts:any = [];
  topStates: any = [];
   xAxisData = [];
   data1 = [];
  data2 = [];
  topRetailersChartOption: EChartsOption;
  topProductsChartOption: EChartsOption;
  topStatesChartOption: EChartsOption;
  initOpts = {
    renderer: 'svg',
    width: 500,
    height: 450
  };
  totalSales: number = 0;
  displaygraph: boolean=true;

  constructor(private overivewService: OverviewService, private router: Router, private currencyPipe: CurrencyPipe) {
    super();  
    const token: string = localStorage.getItem('accessToken'); 
    let decoded_token: any = helper.decodeToken(token);
    let current_userRole: string = decoded_token.role;
   
    if (current_userRole == "Sales Rep"){
      this.displaygraph = false;
    }
    if (current_userRole == "Customer Service"){
      this.router.navigateByUrl('features/retailers/allretailers')
      return //"{'diasplay':'none'}";
    }
    this.getAllRechargesData();
    
  }
    
   
  // Top retailers chart
  drawTopRetailers(){
    let _retailers: string[] = this.topRetailers.map(d => d.userName);
    let _amounts: any = this.topRetailers.map(d => parseFloat(d.amount).toFixed(2));
    this.topRetailersChartOption = {
      title: {
        // text: 'pages.newRetailer.top20Retailers',
        text: `Top 20 Retailers (Total Retailers : ${this.totalRetailers})`,
        //subtext: `Total Retailers : ${this.totalRetailers}`,
        left: 'center',
        /*textStyle: {
          fontSize: 22
        },
        subtextStyle: {
          fontSize: 22
        }*/
    },
      grid: {
        left: '3%',
        right: '10%',
        bottom: '3%',
        containLabel: true
      },
      yAxis: {
        type: 'category',
        data: [...new Set(_retailers)],
        axisLabel: {
          interval: 0,
          //rotate: 45, //If the label names are too long you can manage this by rotating the label.
        },
        axisTick: {
          alignWithLabel: true,
        },
        nameTextStyle: {
          fontSize: 22
        }
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          formatter: '$ {value}',
        },
        nameTextStyle: {
          fontSize: 22
        }
      },
      dataZoom: [
        {
          type: 'inside',
        },
      ],
      series: [
        {
          data: [... new Set(_amounts)],
          type: 'bar',
          barWidth: '40%',
          itemStyle: {
            color: 'rgb(15, 34, 69)'
          },
          // itemStyle: {
          //   color: new LinearGradient(0, 0, 0, 1, [
          //     { offset: 0, color: '#414198' },
          //     { offset: 0.5, color: 'rgb(15, 34, 69)' },
          //     { offset: 1, color: '#414198' },
          //   ]),
          // },
          // emphasis: {
          //   itemStyle: {
          //     color: new LinearGradient(0, 0, 0, 1, [
          //       { offset: 0, color: 'rgb(15, 34, 69)' },
          //       { offset: 0.7, color: '#505098' },
          //       { offset: 1, color: '#5d5da9' },
          //     ]),
          //   }
          // },
          animationDelay: (idx) => idx * 10,
        },
      ],
      animationEasing: 'elasticOut',
      animationDelayUpdate: (idx) => idx * 5,
      tooltip: {
        trigger: 'axis',
        textStyle: {
          fontSize: 20,
          //fontWeight:'500',
        },
        // axisPointer: {
        //   type: 'shadow',
        // },
        formatter: (d)=> {
          return `${d[0].name} : $ ${d[0].value}`}
        },

    };
  }

  // Chart with top products data
  drawTopProducts() {
    let _products: string[] = this.topProducts.map(d => d.productName);
    this.topProductsChartOption = {
       title: {
        // text: 'pages.newRetailer.top20Products',
        text: `Top 20 Products (Total Products : ${this.totalProducts})`,
        // subtext: 'pages.newRetailer.totalProducts'
        //subtext: `Total Products : ${this.totalProducts}`,
        left: 'center'
    },
      grid: {
        left: '3%',
        right: '10%',
        bottom: '3%',
        containLabel: true
      },
      yAxis: {
        type: 'category',
        data: this.topProducts.map(d => d.productName),
        axisLabel: {
          interval: 0,
         // rotate: 45, //If the label names are too long you can manage this by rotating the label.
        },
        axisTick: {
          alignWithLabel: true,
        },
        nameTextStyle: {
          fontSize: 22
        }
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          formatter: '${value}',
          inside: false,
          margin: 45,
        },
        nameTextStyle: {
          fontSize: 22
        }
      },
      dataZoom: [
        {
          type: 'inside',
        },
      ],
      series: [
        {
          data: this.topProducts.map(d => parseFloat(d.amount).toFixed(2)),
          type: 'bar',
          itemStyle: {
            color: 'rgb(15, 34, 69)',

          },
          animationDelay: (idx) => idx * 10,
        },
      ],
      animationEasing: 'elasticOut',
      animationDelayUpdate: (idx) => idx * 5,
      tooltip: {
        trigger: 'axis',
        textStyle: {
          fontSize: 20,
          //fontWeight:'500',
        },
        formatter: (d) => {
          
          return `${d[0].name} :  ${this.currencyPipe.transform(d[0].value)}`
        }
      },

    };
  }
  

  // Chart with top states data
  drawTopStates() {
    let _states: string[] = this.topStates.map(d => d.state);
    
    this.topStatesChartOption = {
      title: {
        // text: 'pages.newRetailer.top20Retailers',
        text: `Top 20 states with maximum sales (Total Sales :  ${ this.currencyPipe.transform(this.totalSales)})`,
        subtext: `(Total Orders : ${this.totalSalesCount}) `,
        left: 'center',
      },
      yAxis: {
        type: 'category',
        data: this.topStates.map(d => d.state),
        axisTick: {
          alignWithLabel: true,
        },
        silent: false,
        splitLine: {
          show: false,
        },
        nameTextStyle: {
          fontSize: 22
        }
      },
      xAxis: {
        type: 'value',
        axisLabel: {
          formatter: '$ {value}',
        },
        nameTextStyle: {
          fontSize: 22
        }
      },
      series: [
        {
          data: this.topStates.map(d => parseFloat(d.amount).toFixed(2)),
          type: 'bar',
          itemStyle: {
            color: 'rgb(15, 34, 69)'
          },
          animationDelay: (idx) => idx * 10,
        },
      ],
      animationEasing: 'elasticOut',
      animationDelayUpdate: (idx) => idx * 5,
      tooltip: {
        trigger: 'axis',
        textStyle: {
          fontSize: 20,
          //fontWeight:'500',
        },
        formatter: (d) => {
          
          return `${d[0].name} : ${this.currencyPipe.transform(d[0].value)}`
        }
      },
    };
  }



  ngOnInit(): void {
    super.ngOnInit()
  }

       

  ngOnDestroy(): void {
    super.ngOnDestroy()
  }


   /**
    * @param retailer
    * @param products
    * @param states
    * @param All
    **/

   // defealut ai call to get data for all recharges '30 days' 
  getAllRechargesData() {
    this.getRechargesData('All', 30)
      .subscribe(res => {
        if (res['httpcode'] == 200) {
          this.allRechargesData = res['data'];
          let _retailers: any = this.allRechargesData['topRetailers'].map(d => d.retailerId);
          let _products: any = this.allRechargesData['topProducts'].map(d => d.productId);
          this.topRetailers = this.allRechargesData['topRetailers'];
          this.topProducts = this.allRechargesData['topProducts'];
          this.topStates = this.allRechargesData['topStates'];
          this.totalSales = this.allRechargesData['topStates'].map(d => d.amount).reduce((acc, curr) => {
            return parseFloat(acc) + parseFloat(curr)
          }, 0)
          this.totalRetailers = [...new Set(_retailers)].length;
          this.totalProducts = [...new Set(_products)].length;
          this.totalSalesCount = this.allRechargesData['topStates'].length;
          this.drawTopRetailers();
          if(this.displaygraph){
            this.drawTopProducts();
            this.drawTopStates();
          }
        }
      });
  }



  // Event on top states date selction change
  onSelectRetailerDateRange(days){
    let type = 'retailer';
     this.getRechargesData(type, days).subscribe(res => {
      
      if(res['httpcode'] == 200){
        let _retailers: any = res['data']['topRetailers'].map(d => d.retailerId);
        this.topRetailers = res.data['topRetailers']
        this.totalRetailers = [...new Set(_retailers)].length;
        this.drawTopRetailers();
      }
    })
  }

  // Event on top products date selction change
  onSelectProductsDateRange(days){
    let type = 'products';
    this.getRechargesData(type, days).subscribe(res => {
      if (res['httpcode'] == 200) {
        let _products: any = res['data']['topProducts'].map(d => d.productId);
        this.topProducts = res['data']['topProducts'];
          this.totalProducts = [...new Set(_products)].length;
          this.drawTopProducts();
          
      }
    })
  }

  // Event on top states date selction change
  onSelectStatesDateRange(days) {
    let type = 'states';
    this.getRechargesData(type, days).subscribe(res => {
      if (res['httpcode'] == 200) {
        let _states: any = res['data']['topStates'].map(d => d.id);
        this.topStates = res['data']['topStates']
        this.totalSales = res['data']['topStates'].map(d => d.amount).reduce((acc,curr)=>{
          return parseFloat(acc) + parseFloat(curr)
        },0)
        this.totalSalesCount = res['data']['topStates'].length;
        this.drawTopStates();
        
      }
    })
  }
  /**
     * @param retailer
     * @param products
     * @param states
     * @param All
     **/
  // common method for returning subscription of selected type & date range
  getRechargesData(type, days){
    this.daysSelected = days
    if (this.daysSelected == 1){
      let endDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
      let startDate = endDate;
      
      return this.overivewService.getTopRetailers(type, startDate, endDate)
    }
    this.currentDate = new Date();
    this.fromDate = this.currentDate.setDate(this.currentDate.getDate() - this.daysSelected);
    let endDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    let startDate = formatDate(this.fromDate, 'yyyy-MM-dd', 'en');
    
    return this.overivewService.getTopRetailers(type, startDate, endDate)
  }

}
